import React from "react";

import logo from "../../../images/logo-segfy.svg";
import {
  Panel,
  Glow,
  Logo,
  Middle,
  Badge,
  Title,
  Description,
  PerkList,
  Perk,
  Footer,
} from "./styles";

const PERKS = [
  "Seus dados sempre protegidos",
  "Suporte humano de verdade quando você precisar",
  "Disponível de onde você estiver",
];

const BrandPanel: React.FC = () => {
  return (
    <Panel>
      <Glow variant="top" />
      <Glow variant="bottom" />

      <Logo src={logo} alt="Segfy" />

      <Middle>
        <Badge>
          <span />
          Você + seguro
        </Badge>
        <Title>
          Você cuida dos seus clientes. <span>A gente cuida de você.</span>
        </Title>
        <Description>
          Seus dados protegidos e um time humano sempre por perto. A gente
          segue junto, todos os dias.
        </Description>
        <PerkList>
          {PERKS.map((perk) => (
            <Perk key={perk}>
              <span>✓</span>
              {perk}
            </Perk>
          ))}
        </PerkList>
      </Middle>

      <Footer>Segfy Tecnologia S/A · © 2026 Segfy ®</Footer>
    </Panel>
  );
};

export default BrandPanel;
